import { isExternalLink } from "@/utils/ensure-protocol-helper"

export interface MenuItem {
  id: number
  name: string
  slug: string
  parent: number | null
  order: number
  url: string
  chosen?: boolean
  selected?: boolean
}

interface Menu {
  id: number
  title: string
  url: string
  attribute?: Menu[]
}

function createMenuStructure(items?: MenuItem[]): Menu[] {
  const menu: Menu[] = []
  let currentParent: Menu | null = null
  let currentChild: Menu | null = null

  items &&
    items.forEach(item => {
      const formattedUrl = isExternalLink(item.url) ? item.url : `/${item.url}`

      if (item.parent === 0) {
        currentParent = {
          id: item.id,
          title: item.name,
          url: formattedUrl,
          attribute: [],
        }
        menu.push(currentParent)
        currentChild = null // Reset currentChild khi gặp parent = 0
      } else if (item.parent === 1 && currentParent) {
        const child: Menu = {
          id: item.id,
          title: item.name,
          url: formattedUrl,
          attribute: [],
        }
        currentParent.attribute?.push(child)
        currentChild = child
      } else if (item.parent === 2 && currentChild) {
        const subChild: Menu = {
          id: item.id,
          title: item.name,
          url: formattedUrl,
          attribute: [],
        }
        currentChild.attribute?.push(subChild)
      }
    })

  return menu
}

export default createMenuStructure
